import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-review-testing',
  templateUrl: './review-testing.component.html',
  styleUrls: ['./review-testing.component.sass']
})
export class ReviewTestingComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
